import { useResults } from './useResults';

export const useTournamentsByPlayer = (playerId, year) => {
  const { data } = useResults(playerId, year);
  return {
    data,
  };
};
